import React from "react";
// import FieldError from "./FieldError";

const TextInput = ({
  label,
  value,
  name,
  type = "text",
  placeholder = "Type here",
  descriptionPosition = "belowLabel",
  error,
  ...props
}) => {
  return (
    <div
      className={`${props.marginCss ?? "mb-4"} ${
        props.cssClass ?? ""
      }`}
    >
      {props.hideLabel ? null : (
        <label className="text-sm font-medium mb-1" htmlFor={name}>{label}</label>
      )}
      
      {props.description && descriptionPosition === "belowLabel"
        ? props.description
        : null}
      <input
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={(e) => props.onChange(e.target.value)}
        onKeyUp={(e) => props.onKeyUp(e)}
        readOnly={props.readonly}
        className={`w-full border p-2 rounded ${error ? "!border-red-500 !border-2" : ""} `}
      />
      {props.description && descriptionPosition === "belowInput"
        ? props.description
        : null}
      {/* <FieldError error={props.error} /> */}
    </div>
  );
};

export default TextInput;
